module.exports = __webpack_public_path__ + "static/media/slide_three.resized.b611996f.jpg";